import {
  AfterViewInit,
  Component,
  OnInit,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation,
} from "@angular/core";
import { Router } from "@angular/router";
import { TooltipService } from "@swimlane/ngx-charts";

@Component({
  selector: "eve-reporting",
  templateUrl: "./app.component.html",
  styleUrls: [
    "./app.component.scss",
    "../../node_modules/primeicons/primeicons.css",
    "../../node_modules/primeng/resources/themes/saga-blue/theme.css",
    "../../node_modules/primeng/resources/primeng.min.css",
  ],
  encapsulation: ViewEncapsulation.ShadowDom,
})
export class AppComponent implements OnInit, AfterViewInit {
  title = "app";

  @ViewChild('shadowdomRoot', { read: ViewContainerRef }) vc: ViewContainerRef;
  constructor(
    private router: Router,
    private chartToolTipService: TooltipService
  ) {
  }

  ngOnInit() {

    this.router.initialNavigation();
  }

  ngAfterViewInit() {
    this.chartToolTipService.injectionService.setRootViewContainer(this.vc);
  }
}
